<template>
  <div class="invoicing width-responsiveness">
    <CreditRequestModal
      ref="creditRequestModal"
      @payment-requested="openConfirmationPaymentRequestModal"
      @modal-closed="refreshPaymentHistory"
    />

    <Toast
      title="Saldo solicitado!"
      message="Seu saldo será atualizado assim que o pagamento for processado."
      url-icon="/static/images/success-green.svg"
      :show="showToast"
      @close="closeToast"
    />

    <template v-if="toggle.billetLink">
      <div class="invoicing__content">
        <div class="invoicing__header">
          <h1>Financeiro</h1>

          <button
            v-if="toggle.prePaid"
            class="btn btn-primary btn-regular-size"
            @click="handleOpenCreditRequestModal"
          >
            <img src="/static/images/icon-plus.svg">
            Adicionar Saldo
          </button>
        </div>

        <DynamicTabs
          :tabs="toggle.prePaid ? allTabs : limitedTabsByFeatureFlag"
          :active-tab.sync="activeTabIndex"
        />

        <div v-if="currentTab === 'gestao'">
          <div
            v-if="toggle.prePaid"
            class="invoicing__box-cards"
          >
            <FinancialCard
              v-for="(card, index) in financialCards"
              :key="index"
              :title="card.title"
              :subtitle="card.subtitle ? card.subtitle : timeAgo.phrase"
              :bold-subtitle="card.boldSubtitle ? card.boldSubtitle : timeAgo.time"
              :value="card.value"
              :is-currency="card.isCurrency"
              :text-color-class="card.textColorClass"
              @click.native="handleOpenPaymentStatement(card)"
            />
          </div>

          <BillingsListTable />
        </div>

        <div v-if="currentTab === 'historico'">
          <PaymentHistory ref="paymentHistory" />
        </div>

        <div
          v-if="currentTab === 'precos'"
          class="invoicing__content-tab"
        >
          <div class="tab-title">
            <h5>Lista de preços</h5>

            <div class="invoicing__box-search">
              <div class="invoicing__search">
                <input
                  v-model="filterText"
                  class="search-input"
                  placeholder="Pesquisar..."
                >
                <img
                  class="search-icon"
                  src="/static/images/icon-search-purple.svg"
                >
              </div>

              <button
                class="pdf-export"
                @click="downloadTablePriceAsPDF"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Exportar Lista de preços em PDF
                </md-tooltip>

                <Spinner v-if="isDownloadingList" />
                <template v-else>
                  <md-icon
                    md-src="/static/images/pdf.svg"
                    class="icon-download"
                  />
                  Exportar
                </template>
              </button>
            </div>
          </div>
          <div class="invoicing__tables-box">
            <Table
              :list="filteredPriceList"
              :columns="examColumns"
              :is-loading-list="isLoadingList"
              :table-size="100"
              @orderBy="orderByProp"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { mask } from 'vue-the-mask'
import notify from '@/api/notification'
import billings from '@/api/billings'
import payments from '@/api/payments'

import { formatPrice } from '@/utils/formatPrice'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'

import DynamicTabs from '@/components/common/DynamicTabs'
import BillingsList from '@/components/Invoicing/components/BillingsList'
import Table from '@/components/common/Table'
import Pagination from '@/components/common/Pagination'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import Spinner from '@/components/common/Spinner'
import FinancialCard from './components/FinancialCard'
import BillingsListTable from './components/BillingsListTable'
import PaymentHistory from './components/PaymentHistory'
import CreditRequestModal from './components/CreditRequestModal.vue'
import Toast from '../common/Toast.vue'

export default {
  name: 'InvoicingView',
  components: {
    DynamicTabs,
    BillingsList,
    Table,
    Pagination,
    AdvancedSelect,
    Spinner,
    FinancialCard,
    BillingsListTable,
    PaymentHistory,
    CreditRequestModal,
    Toast
  },
  directives: {
    mask: mask
  },
  beforeRouteLeave(to, from, next) {
    this.cleanInvoiceList()
    next()
  },
  data() {
    const tab = this.$route.query.tab || 'gestao'
    // const tabMapping = this.toggle['prePaid']
    //   ? { gestao: 0, historico: 1, precos: 2 }
    //   : { gestao: 0, precos: 1 }

    const tabMapping = { gestao: 0, precos: 1 }
    //   ? { gestao: 0, historico: 1, precos: 2 }
    //   :

    return {
      allTabs: [{ title: 'Gestão' }, { title: 'Histórico de Pagamentos' }, { title: 'Lista de Preços' }],
      limitedTabsByFeatureFlag: [{ title: 'Gestão' }, { title: 'Lista de Preços' }],
      activeTabIndex: tabMapping[tab],
      currentTab: tab,
      financialCards: [],
      queryTab: this.$route.query.tab,
      priceListData: {},
      examColumns: [
        { name: 'Cod. Exame', propName: 'code_exam', widthPercent: 20, textPosition: 'left' },
        { name: 'Nome Exame', propName: 'name_exam', widthPercent: 60, textPosition: 'left' },
        {
          name: 'R$',
          propName: 'negotiated_price',
          widthPercent: 20,
          textPosition: 'center',
          valueType: 'R$',
          valueToSwitchIfThisPropIsZero: 'national_price'
        }
      ],
      isLoadingList: false,
      isDownloadingList: false,
      filterText: '',
      financialPassword: '',
      errorMessage: '',
      lastUpdated: new Date(),
      now: new Date(),
      intervalNow: null,
      intervalFetch: null,
      showToast: false
    }
  },
  computed: {
    ...mapGetters(['profile', 'billingsList', 'toggle']),
    firstTabSelected() {
      return this.currentTab === 'gestao'
    },
    filteredPriceList() {
      if (!this.filterText.trim()) {
        return this.priceListData
      }
      const searchTerm = this.filterText.trim().toLowerCase()
      return this.priceListData.filter(item => {
        return item.code_exam.toLowerCase().includes(searchTerm) || item.name_exam.toLowerCase().includes(searchTerm)
      })
    },
    timeAgo() {
      const minutes = Math.floor((this.now - this.lastUpdated) / 60000)
      if (minutes === 0) {
        return { phrase: 'Atualizado', time: 'agora' }
      } else {
        return { phrase: 'Atualizado há', time: minutes + ' min' }
      }
    }
  },
  watch: {
    activeTabIndex(newIndex) {
      const tabMapping = this.toggle.prePaid ? ['gestao', 'historico', 'precos'] : ['gestao', 'precos']

      this.currentTab = tabMapping[newIndex] || 'gestao'

      if (this.currentTab === 'precos') {
        this.getPriceList()
      } else if (this.currentTab === 'gestao') {
        this.cleanInvoiceList()
        this.fetchEntityResume()
      }

      this.$router.push({ query: { tab: this.currentTab } })
    }
  },
  mounted() {
    this.intervalNow = setInterval(() => {
      this.now = new Date()
    }, 60000)

    this.intervalFetch = setInterval(() => {
      this.fetchEntityResume()
    }, 300000)

    if (this.queryTab) {
      this.currentTab = this.queryTab
      if (this.queryTab === 'precos') {
        this.getPriceList()
      } else if (this.queryTab === 'gestao') {
        this.fetchEntityResume()
      }
    } else {
      this.currentTab = 'gestao'
      this.$router.push({ query: { tab: 'gestao' } })
      this.fetchEntityResume()
    }

    const tabIndex = ['gestao', 'historico', 'precos'].indexOf(this.currentTab)
    this.activeTabIndex = tabIndex !== -1 ? tabIndex : 0
  },
  beforeDestroy() {
    clearInterval(this.intervalNow)
    clearInterval(this.intervalFetch)
  },
  methods: {
    ...mapActions(['cleanInvoiceList']),
    openConfirmationPaymentRequestModal() {
      this.showToast = true
      this.$refs.confirmationPaymentRequest.open()
    },
    refreshPaymentHistory() {
      if (this.currentTab === 'historico' && this.$refs.paymentHistory) {
        this.$refs.paymentHistory.fetchPayments()
      }
    },
    closeToast() {
      this.showToast = false
    },
    getPriceList(data) {
      this.isLoadingList = true

      billings
        .getNegotiatedPriceList()
        .then(res => {
          this.priceListData = res.data
          this.isLoadingList = false
        })
        .catch(err => {
          this.isLoadingList = false
          if (err.data.status === 404) {
            notify({
              title: 'Código de exame não encontrado!',
              message:
                  'Por favor, verifique se digitou o código corretamente ou se o exame foi negociado. Em caso de dúvidas, entre em contato com o seu Executivo de Vendas.'
            })
          } else {
            notify({
              title: 'AVISO: ',
              message: 'Erro ao carregar lista de preços.'
            })
          }
          console.error('err -->', err)
        })
    },
    downloadTablePriceAsPDF() {
      if (!this.isDownloadingList) {
        this.isDownloadingList = true

        billings
          .downloadExamTableAsPDF()
          .then(response => {
            this.isDownloadingList = false
            let fileName = 'Lista de Preços'
            let fileExtension = 'pdf'
            convertBase64ToFile({
              file: response,
              fileName: fileName,
              fileExtension: fileExtension
            })
            notify({
              title: 'AVISO:',
              message: 'Download realizado com sucesso.'
            })
          })
          .catch(err => {
            this.isDownloadingList = false
            notify({
              title: 'AVISO: ',
              message: 'Erro ao gerar o PDF da lista de preços.'
            })
            console.error('err -->', err)
          })
      }
    },
    orderByProp(data) {
      if (data) {
        const { column, sortType } = data
        const sortedList = [...this.priceListData].sort((a, b) => {
          const valueA = a[column]
          const valueB = b[column]

          const isNumericA = !isNaN(parseFloat(valueA)) && isFinite(valueA)
          const isNumericB = !isNaN(parseFloat(valueB)) && isFinite(valueB)

          if (isNumericA && isNumericB) return sortType === 'asc' ? valueA - valueB : valueB - valueA
          else if (isNumericA) return sortType === 'asc' ? -1 : 1
          else if (isNumericB) return sortType === 'asc' ? 1 : -1
          else return sortType === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        })
        this.priceListData = sortedList
      }
    },
    cancelModal() {
      this.$router.push('/dashboard')
    },
    openPaymentStatement() {
      this.$router.push('/faturamento-extrato')
    },
    fetchEntityResume() {
      let minimumAchieved = false
      const now = new Date()
      this.lastUpdated = now
      this.now = now

      if (this.toggle.prePaid) {
        payments
          .getBalance('PREPAID')
          .then(res => {
            minimumAchieved = res.data.minimumAchieved
          })
          .catch(err => {
            console.log('err', err)
          })

        payments
          .getEntityResume('PREPAID')
          .then(({ data }) => {
            const { billingPeriod, balance, creditConsumed, projection } = data

            this.financialCards = [
              {
                title: 'Modalidade Financeira',
                subtitle: 'Período de Faturamento ',
                boldSubtitle: `${billingPeriod.periods[0].initialDay} à ${billingPeriod.periods[0].finalDay}`,
                value: 'Pré Pago',
                isCurrency: false,
                textColorClass: 'financial-card__body-value--bordo'
              },
              {
                title: 'Crédito Disponível',
                value: balance,
                isCurrency: true,
                textColorClass: `financial-card__body-value--${minimumAchieved ? 'red' : 'green'}`
              },
              {
                title: 'Crédito Consumido',
                value: creditConsumed,
                isCurrency: true,
                textColorClass: 'financial-card__body-value--bordo'
              },
              {
                title: 'Projeção Mensal',
                value: projection,
                isCurrency: true,
                textColorClass: 'financial-card__body-value--bordo'
              },
              // vamos implementar esse card na próxima versão
              // {
              //   title: 'Vencimento 31/12/2024',
              //   value: 58.89,
              //   isCurrency: true,
              //   textColorClass: 'financial-card__body-value--bordo'
              // }
            ]
          })
          .catch(err => {
            console.log('err', err)
          })
      }
    },
    handleOpenCreditRequestModal() {
      this.$refs.creditRequestModal.handleOpenCreditRequestModal()
    },
    handleOpenPaymentStatement(card){
      if( card.title === 'Crédito Consumido' ){
        this.openPaymentStatement()
        console.log(card)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../static/stylesheets/variables';

  .invoicing {
    min-height: 100vh;
    padding-top: $mainHeaderHeight;
    margin-top: 3em;
    display: flex;
    justify-content: center;
    font-family: 'Exo 2' !important;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #6d6d6d;

      button {
        font-family: 'Exo 2' !important;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        padding: 0 15px 0 15px;
      }
    }

    &__box-search {
      display: flex;
    }

    &__search {
      display: flex;
      background-color: #fff;
      border-radius: 3px;
      padding: 0.5em 0.3em 0.5em 1em;
      margin-right: 1em;

      .search-input {
        background-color: #fff;
        border: 0;
        font-family: Roboto, sans-serif;
        font-weight: 400;
        color: #4a4a4a;
        min-width: 187px;
        min-height: 19px;
        outline: none;
      }

      .search-icon {
        width: 18px;
        margin-right: 6px;
      }
    }

    &__content {
      flex: 1 1 auto;

      &-tab {
        padding-bottom: 40px;

        & > div {
          display: flex;
        }

        .tab-title {
          margin-bottom: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 1;

          h5 {
            color: #7a7a7a;
            font-weight: 500;
            font-size: 18px;
            text-transform: uppercase;
          }

          .pdf-export {
            padding: 0 15px;
            border: 1px solid #e8eaed;
            border-radius: 5px;
            background: #7f1a54;
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 600;
            height: 40px;
            font-family: 'Exo 2' !important;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            min-width: 131px;
            cursor: pointer;

            .loader {
              width: 25px;
              height: 25px;
              border-top: 5px solid rgba(255, 255, 255, 0.2);
              border-right: 5px solid rgba(255, 255, 255, 0.2);
              border-bottom: 5px solid rgba(255, 255, 255, 0.2);
              border-left: 5px solid #ffffff;
            }

            .md-icon {
              margin: 0;
              margin-right: 6px;
            }
          }
        }
      }

      .dynamic-tab {
        margin-top: 30px;
      }
    }

    &__filter-card {
      background-color: #fff;
      display: block;
      padding: 18px;
      border-radius: 6px;
      margin-bottom: 24px;
      width: 32%;

      h2 {
        margin-bottom: 14px;
      }

      .md-input-container {
        margin: 0;
      }

      .btn-search {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        margin: auto 0;
      }

      .error {
        font-size: 12px;
        color: red;
      }
    }

    &__vision-card,
    &__table-header {
      background-color: #fff;
      display: block;
      padding: 18px;
      border-radius: 6px;
      margin-bottom: 24px;
      width: calc(28% - 30px);
      margin-left: 20px;
      overflow: hidden;

      .md-radio {
        margin: 0;
        margin-top: 12px;
      }
    }

    &__vision-card {
      .box-download-pdf {
        display: flex;
        justify-content: flex-end;
        align-content: flex-end;

        .btn-pdf {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          margin: auto 0;

          .loader {
            width: 25px;
            height: 25px;
            border-top: 5px solid rgba(255, 255, 255, 0.2);
            border-right: 5px solid rgba(255, 255, 255, 0.2);
            border-bottom: 5px solid rgba(255, 255, 255, 0.2);
            border-left: 5px solid #ffffff;
          }
        }
      }
    }

    &__table-header {
      flex: 1;

      > div {
        width: 100%;
      }

      &--total {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
      }
    }

    &__tables-box {
      display: flex;
      flex-wrap: nowrap;
    }

    .vertical-divider {
      display: block;
      width: 20px;
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      border-color: #7f1a54;
    }

    .md-theme-default.md-radio .md-radio-container:after {
      background-color: #7f1a54;
    }

    .observation {
      font-size: 12px;
      margin: -15px 0 20px;
      font-style: italic;
    }

    .password-modal {
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      width: 90%;
      max-width: 600px;

      h3 {
        color: #363636;
      }

      p {
        font-size: 12px;
        margin-top: 6px;
        line-height: 16px;
      }

      &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999999;
      }
    }

    .password-input {
      display: block;
      margin-bottom: 10px;
      padding: 8px;
      width: 100%;
      font-size: 16px;
    }

    .modal-actions {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;

      .btn-outline {
        border: 2px solid #7f1a54;
        color: #7f1a54;
      }
    }

    &__box-cards {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
      flex-direction: row;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(500px);
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
